import { useContext, useEffect, useState } from "react";
import Colors from "../../../../../global/Colors";
import { useCaseListStore } from "../../../FullPages/CaseList/CaseListList/hooks/useCaseListStore";
import { DashboardFilterDispatchContext, DashboardFilterStateContext } from "../context/DashboardFilterContext";
import { setSelected } from "../state/actions";

const ButtonCounter = ({
  title,
  value,
  statusType,
  disabled,
  color = "slate",
  filters,
  updateFilter,
}) => {
  const state = useContext(DashboardFilterStateContext);
  const dispatch = useContext(DashboardFilterDispatchContext);
  const [active, setActive] = useState(false);
  const [hover, setHover] = useState("hover:bg-white hover:text-black");
  const dashboardFilterState = useCaseListStore((state) => state);

  const convertToArr = (value) => {
    //Since the word 'Active' is in several status option selections, need to normalize data to an Array type sent back from localStorage versus SearchContext
    if (!value || value === "") {
      return "";
    }
    if (typeof value === "string") {
      let tryToMakeArray = value.split(",");
      if (typeof tryToMakeArray === "string") {
        let newArr = [];
        newArr.push(tryToMakeArray);
        return newArr;
      } else {
        return tryToMakeArray;
      }
    }
    return value;
  };
  const getInitialActiveStatus = (filterType, name) => {
    const newFilters = new URLSearchParams(filters);
    if (filterType === "overall_status") {
      if (
        newFilters.get("overall_status") ||
        newFilters.get("overall_status__in")
      ) {
        let selectedCaseStatuses = newFilters.get("overall_status")
          ? newFilters.get("overall_status")
          : newFilters.get("overall_status__in");
        if (convertToArr(selectedCaseStatuses).includes(name)) {
          return true;
        }
      }
    }
    if (filterType === "status") {
      if (newFilters.get("status") || newFilters.get("status__in")) {
        let selectedStatuses = newFilters.get("status")
          ? newFilters.get("status")
          : newFilters.get("status__in");

        if (convertToArr(selectedStatuses).includes(name)) {
          return true;
        }
      }
    }
    return false;
  };


  const handleClick = (title) => {
    dashboardFilterState.setShowForm(statusType, false);
    if (!disabled) {
      let arr;
      if (statusType === "overall_status") {
        arr =
          typeof state.filters.overall_status === "string"
            ? state.filters.overall_status.split(",")
            : state.filters.overall_status;
      } else {
        arr =
          typeof state.filters.status === "string"
            ? state.filters.status.split(",")
            : state.filters.status;
      }

      let newArr = [];
      if (!active) {
        newArr = arr.map((item) => item);

        newArr.push(title);
      } else {
        newArr = arr.filter((selected) => selected !== title);
      }
      if (statusType === "overall_status") {
        setSelected(dispatch, {
          filterName: "overall_status",
          filterValue: newArr,
        });
        updateFilter("overall_status__in", newArr.join(","));
       // setActiveChipLabel("overall_status__in", newArr.join(","));
      } else {
        setSelected(dispatch, { filterName: "status", filterValue: newArr });
        updateFilter("status__in", newArr.join(","));
      }
      dashboardFilterState.setMultiSelectSearchSelectedItems(statusType, newArr);
      dashboardFilterState.setActiveChipLabel(statusType, newArr.join(","));
      setActive(!active);
    }
  };
  return (
    <div
      className={
        "m-1 text-xs text-center rounded-lg shadow-lg w-[46.5%] " + hover
      }
      role="button"
      tabIndex={0}
      aria-disabled={disabled}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        padding: "4px 15px",
        border: "1px solid ",
        borderRadius: "35px",
        display: "inline-block",
        textAlign: "center",
        color: getInitialActiveStatus(statusType, title) ? Colors.white : Colors.blue[3],
        backgroundColor: getInitialActiveStatus(statusType, title) ? Colors.blue[3] : Colors.blue[2],
        borderColor: getInitialActiveStatus(statusType, title) ? Colors.blue[3] : Colors.blue[2],
      }}
      onClick={() => handleClick(title)}
      onMouseOver={() => setHover("hover:bg-pink-400 hover:text-white")}
      onMouseOut={() => setHover("hover:bg-white hover:text-black")}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleClick(title);
        }
      }}
    >
      <div data-testid="buttoncounter-title" className="w-full text-center h-8 flex items-center justify-center"
           style={{fontFamily: 'Roboto', fontWeight: 500}}>
        {title} - {value}
      </div>
    </div>
  );
};

export default ButtonCounter;
